import React, { useState } from 'react';
import { HorizontalCarousel } from './horizontal-carousel';
import { useTaxonomy } from '../../hooks/useTaxonomy';

export const BlogPostCarousel = ({ title, posts = [] }) => {
  const [activeCategory, setActiveCategory] = useState('All');
  
  // Fetch categories from taxonomy
  const { data: taxonomyData } = useTaxonomy('article_category');
  const categories = ['All', ...taxonomyData.map(item => item.label)];

  if (!posts || posts.length === 0) return null;

  const filteredPosts = activeCategory === 'All' ? posts : posts.filter(post => post.category === activeCategory);

  const categoryColors = {
    'Visa Guidance': 'bg-[#EEF2F7] text-[#00224F]',
    'Scholarship Guide': 'bg-[#E8F4F4] text-[#3D7A7A]',
    'Career Guide': 'bg-[#FDF6E9] text-[#8B6914]',
    'General': 'bg-[#F5F0F0] text-[#6B5A5A]',
  };

  return (
    <div data-testid="blog-post-carousel">
      {title && (
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl text-[#00224F] mb-6" style={{ fontWeight: 750 }}>{title}</h2>
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${activeCategory === category ? 'bg-[#00224F] text-white' : 'bg-white text-[#5A6978] border border-[#E8E4DF] hover:border-[#00224F]'}`}
                data-testid={`blog-category-${category.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      )}
      
      <HorizontalCarousel itemWidth={320}>
        {filteredPosts.map((post, index) => (
          <a key={index} href={post.href} className="flex-shrink-0 block group" style={{ width: '320px' }} data-testid="blog-post-card">
            <article className="bg-white border border-[#E8E4DF] rounded-xl hover:shadow-lg transition-all duration-200 overflow-hidden h-full">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={post.imageUrl} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" width="320" height="200" />
                {post.category && (
                  <span className={`absolute top-3 left-3 px-3 py-1 rounded text-xs font-medium ${categoryColors[post.category] || 'bg-[#F5F3F0] text-[#5A6978]'}`}>
                    {post.category}
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-semibold text-[#00224F] line-clamp-2 group-hover:text-[#D4A853] transition-colors leading-snug">{post.title}</h3>
                <p className="mt-3 text-sm text-[#D4A853] font-medium">Read more →</p>
              </div>
            </article>
          </a>
        ))}
      </HorizontalCarousel>
    </div>
  );
};
